import { Box, Breadcrumbs, FormLabel, Link, Typography } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { useEffect, useMemo } from "react";
import { Controller } from "react-hook-form";

import { BackButton } from "../../../../../common/components/back_button";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { DefaultDatePickerInput } from "../../../../../common/components/default_date_picker_input";

import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateProjetoColumnDefinition } from "./columns";
import { useDisciplinaItemsViewModel } from "../../viewModels/disciplina_items_view_model";

import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import BottomBar from "../../../../../common/components/bottom_bar";
import { isValidId } from "../../../../../common/utils/utils";
import { DisciplinaItemChecklistLista } from "../../../domain/models/items_disciplina_checklist_lista";
import FormContainer from "../../../../../common/components/form_container";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";


export const CronogramaItensChecklist_cadastro = () => {
  const viewModel = useDisciplinaItemsViewModel();
  const columnsDefinition = useMemo(() => GenerateProjetoColumnDefinition(viewModel.hookForm), [viewModel.hookForm]);

  const statusAtual = viewModel.hookForm.watch("status");
  const arquivo = viewModel.hookForm.watch("arquivo1");
  const nomeArquivo = viewModel.hookForm.watch("nomearquivo1");
  useEffect(() => {
    if (statusAtual === 0) viewModel.setIsFinalizado(false);

  }, [statusAtual, viewModel]);

  useEffect(() => {
    if (arquivo instanceof File) {
      viewModel.hookForm.setValue("nomearquivo1", arquivo.name, { shouldDirty: true });
      viewModel.hookForm.setValue("limparArquivo1", false);
    }
  }, [arquivo, viewModel.hookForm]);


  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <BackButton onClick={() => viewModel.handleProjetoCadastro()} />
          } />
      </PageTopBar>

      <form
        onSubmit={viewModel.hookForm.handleSubmit(
          viewModel.handleUpdateDisciplinaChecklist)}
      >
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">Projetos</Link>
            <Link underline="hover" color="inherit">
              <LinkTo to="/Projetos_lista">Lista de Projetos</LinkTo>
            </Link>
            <Link
              underline="hover"
              color="inherit"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                sessionStorage.setItem("projetoTab", "2");
                window.history.back();
              }}
            >
              Cadastro de Projeto
            </Link>
            <Typography className="text-primary-green">Verificação do Projeto</Typography>
          </Breadcrumbs>
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Verificação do Projeto</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-6 rounded-[8px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4 shadow-sm">

            <div className="flex items-center justify-start pb-6 border-b border-gray-200 dark:border-gray-700 mb-6">
              <FormRadioGroupInput
                name="status"
                label="Status da Análise"
                readOnly={viewModel.saving}
                options={[
                  { id: 0, label: "Em Andamento" },
                  { id: 1, label: "Finalizada" },
                ]}
                reactHookForm={viewModel.hookForm}
              />
            </div>
            <fieldset disabled={viewModel.isFinalizado} className="flex flex-col gap-8">
              <div className="flex flex-col gap-4">
                <DefaultFormInput name="normasTecnicas" multiline rows={3} reactHookForm={viewModel.hookForm} label="Descreva quais normas foram utilizadas para a elaboração do projeto" />
                <DefaultFormInput name="outrosItens" multiline rows={3} reactHookForm={viewModel.hookForm} label="Escreva outros itens, processos ou softwares utilizados, que ajudam a garantir que o projeto possa ser construído" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 bg-gray-50 dark:bg-[#1e1e1e] rounded-md">
                <Box display="flex" flexDirection="column" gap={1}>
                  <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Validado por</FormLabel>
                  <Box display="flex" gap={2} alignItems="flex-start">
                    <Box flex={1}>
                      <DropDownFuncionario name="idFuncionarioValidacao" required={false} readOnly={viewModel.saving} reactHookForm={viewModel.hookForm} />
                    </Box>
                    <Box width="200px">
                      <Controller
                        name="dataValidacao"
                        control={viewModel.hookForm.control}
                        render={({ field }) => <DefaultDatePickerInput label="Data de Validação" value={field.value} onChange={field.onChange} />}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box display="flex" flexDirection="column" gap={1}>
                  <FormLabel sx={{ fontWeight: 600, color: 'text.primary' }}>Verificado por</FormLabel>
                  <Box display="flex" gap={2} alignItems="flex-start">
                    <Box flex={1}>
                      <DropDownFuncionario name="idFuncionarioVerificacao" required={false} readOnly={viewModel.saving} reactHookForm={viewModel.hookForm} />
                    </Box>
                    <Box width="200px">
                      <Controller
                        name="dataVerificacao"
                        control={viewModel.hookForm.control}
                        render={({ field }) => <DefaultDatePickerInput label="Data de Verificação" value={field.value} onChange={field.onChange} />}
                      />
                    </Box>
                  </Box>
                </Box>
              </div>


              <div className="flex flex-col gap-2">
                <FormLabel sx={{ fontWeight: 600, fontSize: '1.1rem', color: 'text.primary' }}>Itens do Checklist</FormLabel>
                <div className="border border-gray-200 dark:border-gray-700 rounded-md overflow-hidden">
                  <StyledDataGrid
                    disableRowSelectionOnClick
                    rows={viewModel.checklistLista}
                    columns={columnsDefinition}
                    getRowId={(row: DisciplinaItemChecklistLista) => row.idDisciplinaItemChecklist}
                    loading={viewModel.loading}
                    tableName={""}
                  />
                </div>
              </div>

              <DefaultFormInput name="observacoes" multiline rows={4} reactHookForm={viewModel.hookForm} label="Observações Adicionais" />

              <FormContainer title={"Anexar Arquivos"} arrangement="fullRow">
                <DefaultFormDownloadInput
                  name="arquivo1"
                  nameLimparFlag="limparArquivo1"
                  saving={viewModel.saving}
                  filename={nomeArquivo ?? null}
                  reactHookForm={viewModel.hookForm}
                  onDeleteFile={() => viewModel.handleDeleteFile('limparArquivo1', 'Arquivo1')}
                  onDownloadFile={filename => viewModel.handleDownloadFile(filename, viewModel.checklist?.idDisciplinaChecklist!)}
                />
              </FormContainer>

            </fieldset>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.checklist) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory()}>
                  <span className="text-xs">
                    Histórico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>
            <div className="flex flex-row gap-4 ml-auto items-center">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold transition-colors">
                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handleProjetoCadastro()}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton disabled>
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={<DynamicIcon nameIcon="CheckRounded" size={22} className="text-white" />}>
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
    </>
  );
};
